<template>
    <Dispatch_date-component>
      <!-- <b-row style="float: inline-end;">
  <div>
    <b-button variant="success" @click="downloadReport" class="nav-link">
  Attendance Report
</b-button>
  </div>
</b-row>   -->
<b-row class="d-flex justify-content-end mb-3">
    <b-button variant="success" @click="downloadReport" class="nav-link">
  Attendance Report
</b-button>
</b-row> 
        <div class="p-2">
          
            <b-row>
              <b-col md="4">
  <b-form-group>
    <b-form-group label="From Date:" :label-cols="4">
      <v-date-picker
        mode="single"
        v-model="selectDate"
        :available-dates="toDateAvailableDates"
        input-class="form-control"
        :input-props="{ readonly: true }"
      />
    </b-form-group>
  </b-form-group>
</b-col>


<b-col md="4">
  <b-form-group>
    <b-form-group label="To Date:" :label-cols="4">
      <v-date-picker
        mode="single"
        v-model="toselectDate"
        :available-dates="{ start: null, end: new Date() }"
        input-class="form-control"
        :input-props="{ readonly: true }"
      />
    </b-form-group>
  </b-form-group>
</b-col>


<b-col md="4">
  <b-form-group label="Select Hub:" :label-cols="4">
    <b-form-select v-model="valueWH">
      <option :value="null">-- Select Hub --</option>
      <option 
        v-for="hub in optionsWH" 
        :key="hub.id" 
        :value="hub.id">
        {{ hub.name }}
      </option>
    </b-form-select>
  </b-form-group>
</b-col>
</b-row>

                <b-row>
                  <b-col md="4">
  <b-form-group label="Regularization Type:" :label-cols="4">
    <b-form-select v-model="regularizationType">
      <option :value="null">-- Select Regularization Type --</option>
      <option 
        v-for="item in regularizationlist" 
        :key="item.name" 
        :value="item.name">
        {{ item.name }}
      </option>
    </b-form-select>
  </b-form-group>
</b-col>



<b-col md="4">
  <b-form-group label="Select Employee Name:" :label-cols="4">
    <b-form-select v-model="valueEmpName">
      <option :value="null">-- Select Employee Name --</option>
      <option 
        v-for="emp in employeelist" 
        :key="emp.id" 
        :value="emp.id">
        {{ emp.name }}
      </option>
    </b-form-select>
  </b-form-group>
</b-col>
<b-col md="4">
  <b-form-group label="Employee ID :" :label-cols="4">
    <b-form-select v-model="empId">
      <option :value="null">-- Employee ID : --</option>
      <option 
        v-for="emp in employeeIDList" 
        :key="emp" 
        :value="emp">
        {{ emp }}
      </option>
    </b-form-select>
  </b-form-group>
</b-col>

</b-row>
                <!-- <b-col md="8"></b-col> -->

                <b-col md="12" class="d-flex justify-content-end p-2">
                    <b-button variant="primary" @click="EmployeeAllRequestList(pageNum)"> Search </b-button>&nbsp;
                    <b-button variant="danger" @click="clear()"> Clear </b-button>&nbsp;
                </b-col>
            
            <b-row>
                <b-col sm="12" class="text-right">
                    <p > <b>Total Records :<span style="color:red;">{{totalUserRows}}</span></b> </p>
                 </b-col>
            </b-row>
            
            <div>
  <ul
    v-for="empitems in employeeitems"
    :key="empitems.id"
    class="p-2 mb-2"
    style="border: 1px solid black; background-color: rgb(198, 241, 200); list-style: none;"
  >
    <b-row>
      <!-- Profile Image -->
      <b-col
        md="2"
        class="d-flex align-items-center justify-content-center border-end"
        style="cursor: pointer;"
        @click="openImgModal(empitems.faceIdValue)"
      >
        <div
          v-if="!empitems.faceIdValue"
          style="
            width: 100px; height: 100px; background-color: #ccc;
            border-radius: 50%; display: flex; align-items: center; justify-content: center;
          "
        >
          <span style="color: #666; font-size: 12px;">No Image</span>
        </div>
        <img
          v-else
          :src="empitems.faceIdValue"
          width="100"
          height="100"
          style="border-radius: 50%; object-fit: cover;"
          alt="Profile"
        />
      </b-col>

      <!-- Employee Info -->
      <b-col md="10">
        <!-- Name + Status + Reason -->
        <div class="mb-2 d-flex align-items-center flex-wrap gap-2">
          <b-button variant="primary" class="btnclass">{{ empitems.emp_name }}</b-button>

          <b-button
            v-if="empitems.status === 'approved'"
            variant="success"
            style="color: #fff;"
            class="btnclass"
          >
            {{ empitems.status }}
          </b-button>

          <b-button
            v-else-if="empitems.status === 'rejected'"
            variant="danger"
            style="color: #fff;"
            class="btnclass"
          >
            {{ empitems.status }}
          </b-button>

          <b-button
            v-else
            variant="secondary"
            style="color: #fff;"
            class="btnclass"
          >
            {{ empitems.status }}
          </b-button>

          <b-button variant="warning" class="btnclass">{{ empitems.reason }}</b-button>
        </div>

        <!-- Info Lines -->
        <div class="mb-2">
          <div>
            <strong>Emp Name:</strong> {{ empitems.emp_name }}
            &nbsp; <strong>Emp Id:</strong> {{ empitems.emp_id }}
          </div>
          <div>
            <!-- {{ empitems }} -->
            <strong>Shift Date:</strong> {{ formatDate(empitems.regularization_createdat) }}
            &nbsp; <strong>Attendance Remark:</strong> 
            <span v-if="empitems.week_off == 'yes'">Week Off</span>
            <span v-if="empitems.week_off == 'no'">{{ empitems.reason }}</span>
          </div>
          <div>
            <span><strong>{{ formatDateTimeNew(empitems.created_date) }}</strong></span>
          </div>
        </div>

        <!-- Date + Actions -->
        

        <div class="d-flex justify-content-between align-items-center">
          <span style="font-weight: bold;">
            {{ empitems.status === 'rejected' || empitems.status === 'approved'
              ? empitems.updatedat
              : empitems.createdat }}
          </span>

          <!-- Action Buttons -->
          <!-- Date + Actions (Unified layout for all statuses) -->

<div class="d-flex justify-content-between align-items-center">
  <!-- Left: Date/Time -->
  

  <!-- Right: Buttons -->
  <div>
    <b-button
      v-if="empitems.status === 'rejected'"
      variant="primary"
      class="btnclass"
      @click="openRejectedViewDetailsModal(empitems)"
    >
      View Details
    </b-button>

    <b-button
      v-else-if="empitems.status === 'approved'"
      variant="primary"
      class="btnclass"
      @click="openApprovedViewDetailsModal(empitems)"
    >
      View Details
    </b-button>

    <template v-else-if="empitems.status === 'pending'">
      <b-button
        variant="primary"
        class="btnclass"
        @click="openViewDetailsModal(empitems)"
      >
        View Details
      </b-button>
      <b-button
        variant="danger"
        style="color: #fff;"
        class="btnclass"
        @click="acceptDetails(empitems, 'rejected')"
        :disabled="userLoggedInType == 2"
      >
        Reject
      </b-button>
      <b-button
        variant="success"
        style="color: #fff;"
        class="btnclass"
        @click="acceptDetails(empitems, 'approved')"
        :disabled="userLoggedInType == 2"
      >
        Approve
      </b-button>
    </template>
  </div>
</div>




        </div>
      </b-col>
    </b-row>
  </ul>

  <!-- Pagination -->
  <!-- // <div v-if="totalUserRows > 10" class="text-center mt-3"> -->
    <paginate v-model="pageNum"
                        :page-count="noofpages"
                        :page-range="10"
                        :margin-pages="2"
                        :click-handler="clickCallback"
                        :prev-text="'Prev'"
                        :next-text="'Next'"
                        :container-class="'pagination'"
                        :page-class="'page-item'">
                    </paginate>
 <!-- //  </div> -->
</div>

          
             <b-modal
                        id="imgview"
                        size="xl"
                        title=""
                        v-model="modalOpen"
                        @ok="modalOpen = false"
                        hide-footer>
                        <div class = "imgclass-2">
                            <img :src="viewImg"  class="modal-img" alt="Custom Marker Icon" />
                        </div>
             </b-modal>

            <b-modal
                        id="imgview"
                        size="xl"
                        title="Emp Details:"
                        v-model="ViewDetailModalOpen"
                        @ok="ViewDetailModalOpen = false"
                        hide-footer>
                        <b-row>
                            <b-col>
                                <div class = "detailsclass">
                           <label>Emp Details,</label><br><br>
                           <label>Emp Name:  <span>{{userAllData.emp_name}}</span></label><br>
                           <label>Emp Id: {{userAllData.emp_id}}</label><br>
                           <label>Hub Name: {{userAllData.hub_id}}</label><br>
                           <label>Face Id: <img style="border: 1px solid black;" :src="userAllData.faceIdValue" width="110" height="110" alt="Custom Marker Icon" /></label><br>
                           
                        </div>
                            </b-col>
                            <b-col>
                              <div class = "detailsclass">

<label>Regularization Status:  <span>{{userAllData.status}}</span></label><br>
<label>Attatchment: 
 <span v-if="userAllData && userAllData.regularization_file"><img :src="userAllData.regularization_file" height="100" width="150" /></span>
 <span v-if="!userAllData && !userAllData.regularization_file">-</span>
</label><br>
<label>comment: {{userAllData.comment}}</label><br>
<label>Regularization Reason:  <span>{{userAllData.reason}}</span></label><br>
<label> Current Attendance Status: Pending
 </label><br>

 <label v-if="userAllData.week_off === 'yes'" > Regularization Raised For: Week Off
 </label><br>

 <label v-if="userAllData.week_off === 'no'" > Regularization Raised For: Present
 </label><br>

<!-- <label> Attendance Remark:
 Week Off</label><br> -->

</div>
                            </b-col>
                            <b-col>
                                <div class = "detailsclass">
                           <label>Shift Details,</label><br><br>

                           <label>Shift Date:  <span>{{formatDate(userAllData.regularization_createdat)}}</span></label><br>
                           <label>Shift Name:  <span>{{userAllData.shift}}</span></label><br>
                           <label>Emp Shift Punch In Time: {{userAllData.effective_start_time}}</label><br>
                           <label>Emp Shift Punch Out Time: {{userAllData.effective_end_time}}</label><br>
                           <label>Overtime Start: {{userAllData.overtime_start_time}}</label><br>
                           <label>Overtime End: {{userAllData.overtime_end_time}}</label><br>
                           <label>Total Break Duration: {{userAllData.break_duration}}</label><br>
                        </div>
                                </b-col>
                        </b-row>
                        <b-row class="d-flex justify-content-center p-4" v-if="userAllData.overtime_start_time && userAllData.overtime_end_time">
                          <label><strong>Total Break Duration: {{ getTimeDifference(userAllData.overtime_start_time, userAllData.overtime_end_time) }}</strong></label>
                        </b-row>
                        <b-row class="d-flex justify-content-center" v-if="userAllData.status ==='pending'">
                            <b-button 
    variant="danger" 
    style="color: #fff;" 
    class="btnclass" 
    @click="acceptDetails(userAllData,'rejected')"
    :disabled="userLoggedInType == 2"
  > 
    Reject 
  </b-button>&nbsp;
  
  <b-button 
    variant="success" 
    style="color: #fff;" 
    class="btnclass" 
    @click="acceptDetails(userAllData,'approved')"
    :disabled="userLoggedInType == 2"
  > 
    Approve 
  </b-button>
                        </b-row>
                        
            </b-modal>

            <b-modal
                        id="imgview"
                        size="xl"
                        title="Emp Details:"
                        v-model="RejectedViewDetailModalOpen"
                        @ok="RejectedViewDetailModalOpen = false"
                        hide-footer>
                        <div class = "detailsclass">
                        <b-row>
                            <b-col md="6">
                                <label>Request Raised by,</label><br><br>

                                <label>Emp Name:  <span>{{empdetails.username}} {{empdetails.lastname}}</span></label><br>
                                <label>Emp Email:  <span>{{empdetails.createdby}}</span></label><br>
                                <label>Emp Id: {{empdetails.employeeid}}</label><br>
                                <label>Mob No: {{empdetails.contactnumber}}</label><br>
                                <label>Face Id: <img style="border: 1px solid black;" :src="empdetails.faceIdValue" width="110" height="110" alt="Custom Marker Icon" /></label><br>
                                <label>Hub Name: {{empdetails.name}}</label><br>
                                <label>Request Date & Time: {{empdetails.createdat}}</label><br>
                            </b-col>
                            <b-col md="6">
                                <label>Request Rejected by,</label><br><br>

                                <label>Reporting Manager Name:  <span>{{approverejectdetails.userfirstname}} {{approverejectdetails.userlastname}}</span></label><br>
                                <label>Reporting Manager Email:  <span>{{approverejectdetails.sysemailid}}</span></label><br>
                                <label>Reporting Manager Id: {{approverejectdetails.empid}}</label><br>
                                <label>Rejected Date & Time: {{empdetails.updatedat}}</label><br>
                            </b-col>
                        </b-row>
                        

                        </div>
            </b-modal>

            <b-modal
                        id="imgview"
                        size="xl"
                        title="Emp Details:"
                        v-model="ApprovedViewDetailModalOpen"
                        @ok="ApprovedViewDetailModalOpen = false"
                        hide-footer>
                        <div class = "detailsclass">
                        <b-row>
                            <b-col md="6">
                                <label>Request Raised by,</label><br><br>

                                <label>Emp Name:  <span>{{empdetails.username}} {{empdetails.lastname}}</span></label><br>
                                <label>Emp Email:  <span>{{empdetails.createdby}}</span></label><br>
                                <label>Emp Id: {{empdetails.employeeid}}</label><br>
                                <label>Mob No: {{empdetails.contactnumber}}</label><br>
                                <label>Face Id: <img style="border: 1px solid black;" :src="empdetails.faceIdValue" width="110" height="110" alt="Custom Marker Icon" /></label><br>
                                <label>Hub Name: {{empdetails.name}}</label><br>
                                <label>Request Date & Time: {{empdetails.createdat}}</label><br>
                            </b-col>
                            <b-col md="6">
                                <label>Request Approved by,</label><br><br>

                                <label>Reporting Manager Name:  <span>{{approverejectdetails.userfirstname}} {{approverejectdetails.userlastname}}</span></label><br>
                                <label>Reporting Manager Email:  <span>{{approverejectdetails.sysemailid}}</span></label><br>
                                <label>Reporting Manager Id: {{approverejectdetails.empid}}</label><br>
                                <label>Approved Date & Time: {{empdetails.updatedat}}</label><br>
                            </b-col>
                        </b-row>
                        

                        </div>
            </b-modal>
        </div>
    </Dispatch_date-component>
</template>

<script>
import CONSTANTS from "@/utils/constants";
import Utils from "@/utils";
import auth from "@/utils/auth";
export default {
//     components: {
//     Modal
//   },
    data() {
        return {
            selectDate : new Date(),
            toselectDate : new Date(),
            modalOpen: false,
            ViewDetailModalOpen: false,
            RejectedViewDetailModalOpen: false,
            ApprovedViewDetailModalOpen: false,
            items: [],
            totalRows :0,
            employeeitems : [],
            empdetails : {},
            approverejectdetails:{},
            employeelist : [],
            selected_employee : null,
            isBusy : false,
            valueWH:null,
            fieldWH:{ text: 'name', value: 'id' },
            optionsWH:[],
            WHData:[],
            showSelectAll : true,
            loadurl :'',
            LoadDetails:[],
            totalUserRows: 0,
            loadisBusy : false,
            loaddetailsmodel : false,
            pinnoofpages : '',
            pinlistingpageno :1,
            pageNum:1,
            searchingdata : false,
            viewImg:'',
            toDateAvailableDates: { start: null, end: new Date() },
            empData: [],
            valueEmpName: null,
            employeeIDList: [],
        empId: null,
        regularizationlist: [
        { name: 'Missed Punch Out', value: 'Missed Punch Out' },
        { name: 'Mistakenly Punched Out early', value: 'Mistakenly Punched Out early' },
        { name: 'New Joinee, was not registered in fc clock', value: 'New Joinee, was not registered in fc clock' },
        { name: 'Missed both punch in and punch out', value: 'Missed both punch in and punch out' },
        { name: 'Punched in Late', value: 'Punched in Late' },
        { name: 'Did late break end', value: 'Did late break end' },
        { name: 'Week Off', value: 'Week Off' },
        { name: 'Missed Ot End', value: 'Missed Ot End' },
        { name: 'Missed Ot End', value: 'Missed Ot End' },
        { name: 'Missed Ot Start & Ot End', value: 'Missed Ot Start & Ot End' },
        { name: 'Mistakenly marked Ot end early', value: 'Mistakenly marked Ot end early' },
        { name: 'Missed Ot Start late', value: 'Missed Ot Start late' },
        { name: 'Other Reason', value: 'Other Reason' }
        ],
        regularizationType: null,
        userAllData: {},
        progress:0,
        userLoggedInType: '',
        noofpages:'',
        }
    },

    created() {
        var userdata = localStorage.getItem("userData");
        var userInfo = JSON.parse(userdata);
        this.userLoggedInType = userInfo.user_type
        console.log(userInfo, 'userInfouserInfo@123')
        this.showWHlist();
        this.showEmplist();
        this.showEmpIDlist()
        this.EmployeeAllRequestList(this.pageNum)
    },

    methods: {
  selectsearchemployee(selected_employee) {
            if(selected_employee==null){
                this.selected_employee="";
                this.displayAllData(this.pageNum);
            }
        },
  updateToDateAvailableDates() {
      const endDate = this.selectDate ? new Date(this.selectDate) : new Date();
      endDate.setHours(23, 59, 59, 999); // Set end of the day
      this.toDateAvailableDates = { start: null, end: endDate };
    },
        acceptDetails(details,regularizationStatus)
        {
        var userdata = localStorage.getItem("userData");
        var userInfo = JSON.parse(userdata);

        //   var userID = details.userid;
        //   var remark = regularizationStatus;
        //   var regularizationStatus = regularizationStatus;
        //   var email = userInfo.sysemailid;
            let status = ''
          if (regularizationStatus === 'approved') {
            regularizationStatus = 'approved';
            status = "present"
          } else {
            regularizationStatus = 'rejected';
            status = "singlepunch"
          }
          const data = {
            employeeID: details.emp_id,
            punchedInAt: `${this.formatDate(details.regularization_createdat)} ${details.effective_start_time}`,
            punchedOutAt: `${this.formatDate(details.regularization_createdat)} ${details.effective_end_time}`,
            status: status,
            regularizationStatus: regularizationStatus
          }
          console.log("data", data);
          // return false;
          this.$http
            .post(
            `${CONSTANTS.MIGRATION_API_URL}/updateRequestFcClockRegularization`,
            [data]
            )
            .then((result) => {
           
                if(result.body.message == 'success')
                {
                    this.$fire({
                    text: 'Successfully Update',
                    type: "success",
                    timer: 30000,
                    });
                    this.ViewDetailModalOpen = false;
                    this.EmployeeAllRequestList(this.pageNum)
                }else{
                    this.$fire({
                    text: result.body.message,
                    type: "error",
                    timer: 30000,
                });
                }
            
            })
            .catch((ex) => {
            console.log("error", ex);
            });

        },
        // pinclickCallback(pinpageNum){
        //     console.log("click back--------->");

        //     this.pinlistingpageno = pinpageNum;
        //     if(this.searchingdata)
        //     {
        //      this.EmployeeAllRequestList(this.pinlistingpageno);
        //     }else{
        //       this.EmployeeAllRequestList(this.pinlistingpageno);
        //     }
        // },
        showEmplist: function() {

var userdata = localStorage.getItem("userData");
var userInfo = JSON.parse(userdata);

// this.employeelist=[];
const deliveryagentobj = {
    sysusermasterid: `${userInfo.sysusermasterid}`,
    usertype: `${userInfo.user_type}`,
    hub_id: this.valueWH ? this.valueWH: null,
};
this.$http
.post(
`${CONSTANTS.MIGRATION_API_URL}/getAllFcClockRegularizationEmpListing`,deliveryagentobj

)
.then((result) => {
console.log("YYY", result);
if (result.body.returnmsg === 'Successful') {
  
      this.empData  = result.body.returnvalue;
      for(let j = 0; j < this.empData.length; j++) {
          let emp = {
          name: this.empData[j].username + " - " + this.empData[j].employeeid,
          id: this.empData[j].username,
          }

      this.employeelist.push(emp);
      }
  
  } else {              
    this.employeelist = []
  }

})
.catch((ex) => {
console.log("error", ex);
});
},
        getuserdata(empdata)
        {
           this.empdetails = empdata;
           this.approverejectdetails = {};

           const empobj = {
                useremailid: `${empdata.updatedby}`
            };

            this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getUserdetails`, empobj)
            .then((result) => {
            if (result.data.returnvalue.length > 0) 
            {
                this.approverejectdetails = result.data.returnvalue[0];
            } else {
                this.approverejectdetails = {};
            }
            })
            .catch((ex) => {
            console.log("error", ex);
            });
        },
        openRejectedViewDetailsModal(empdata)
        {
            this.getuserdata(empdata);
           this.userAllData =empdata
           this.ViewDetailModalOpen = true;
        },
        openApprovedViewDetailsModal(empdata)
        {
           this.getuserdata(empdata);
           this.userAllData =empdata
           this.ViewDetailModalOpen = true;
        },
        openViewDetailsModal(empdata){
            console.log("empdata", empdata);
           this.getuserdata(empdata);
        this.userAllData =empdata
        console.log("userAllData",this.userAllData);
           this.ViewDetailModalOpen = true;
        },
        openImgModal(Img) {
            this.viewImg = Img;
            this.modalOpen = true;
            },
     
        fetchFaceIdData(employees) {
            console.log("empliye--------->");
            const faceIdPromises = employees.map((employee) => {
                return this.$http
                .post(`${CONSTANTS.MIGRATION_API_URL}/getImageUrl`, { faceid: `${employee.faceid}` }) // Assuming employee has an 'id' field
                .then((response) => {
                    //console.log("response.data------>",response.data);
                    // You can process the Face ID response as needed
                    var faceId = 'https://cdn-icons-png.flaticon.com/128/63/63820.png';
                    if(response.data.length)
                    {
                        faceId = response.data[0].image;
                    }
                    return { ...employee, faceIdValue: faceId }; // Adjust based on your API response
                })
                .catch((ex) => {
                    console.error(`Error fetching Face ID for employee ${employee.id}`, ex);
                    return { employeeId: employee.id, faceIdValue: 'https://cdn-icons-png.flaticon.com/128/63/63820.png' }; // Handle error case
                });
            });

            Promise.all(faceIdPromises)
                .then((results) => {
                    this.employeeitems = results; // Store all Face ID data
                console.log('Face ID Data:',  this.employeeitems); // Check the results
                })
                .catch((ex) => {
                console.error("Error fetching Face ID data", ex);
                });
            },
        showWHlist:function(){
          
            var userdata = localStorage.getItem('userData')
            var userInfo = JSON.parse(userdata)
            
            var csvObj = {
                sysusermasterid:`${userInfo.sysusermasterid}`,
                usertype:`${userInfo.user_type}`
            };
            this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getAllHubList`, csvObj)
              .then(result => {
                
                if (result.body.returnmsg === 'Successful') {
                    this.optionsWH=[];
                
                    this.WHData  = result.body.returnvalue;
                    
                    for(let j = 0; j < this.WHData.length; j++) {
                        let WH = {
                        name: this.WHData[j].hub_title + " - " + this.WHData[j].fcclock_hubid,
                        id: this.WHData[j].fcclock_hubid,
                        }
                    this.optionsWH.push(WH);
                    }
                
                } else {              
                    this.WHData  = result.body.returnvalue;
                }
            
  
            })
            .catch(ex => {
                console.log("error-----", ex);
            });
        },

        formatDateNew(date) {
  if (!date) return null;
  const d = new Date(date);
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
},
        EmployeeAllRequestList : function (pagenum) {

          console.log(this.selectDate, 'this.selectDate')
            console.log(this.toselectDate, 'this.toselectDate')
            // return false;
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);
            
            this.isBusy = true;
            var selectDate = (this.selectDate!=null)?this.formatDateNew(this.selectDate):"";
            var toselectDate = (this.toselectDate!=null)?this.formatDateNew(this.toselectDate):"";
            console.log("selectDate--->",selectDate);
            // return false;
            let user_id = null;
console.log("this.selected_employee--->",this.selected_employee);

if (!this.selected_employee || this.selected_employee === 'null') {
  // Case: null, undefined, or literal string "null"
  console.log("null--->11111111");
  user_id = null;
} else {
  // Safe access
  console.log("not null--->22222222", 'this.selected_employee');
  // user_id = (this.selected_employee && this.selected_employee.key) || "";
  user_id = (this.selected_employee && this.selected_employee) || "";
}

            
            
            const obj = {
                sysusermasterid:`${userInfo.sysusermasterid}`,
                startdate : selectDate,
                enddate : toselectDate,
                user_id : user_id || null ,
                warehouseid : this.valueWH ? this.valueWH : null,
                page_no:`${pagenum}`,
                emp_name: this.valueEmpName ? this.valueEmpName : null,
                regularizationType: this.regularizationType ? this.regularizationType : null,
                emp_id: this.empId ? this.empId : null,
                status: [
                    'pending',
                    'approved',
                    'rejected'
                ]
            } 
            console.log("object------------->",obj);
            // return false
            this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getAllListingForFcClockRegularization`,obj)
            .then(result =>{
                this.isBusy = false;
                console.log("resilky 00==>",result);
                if (result.body.returnmsg === "Successful" && result.data.returnvalue.length > 0) {
                    this.searchingdata = true;
                    this.employeeitems = result.data.returnvalue;
                    this.fetchFaceIdData(this.employeeitems);
                    this.totalUserRows = result.data.returnvalue[0].totalcount;

                    this.noofpages=parseInt(this.employeeitems[0].totalcount)/10;
                    this.noofpages=Math.ceil( this.noofpages);
                
                } else {
                    this.employeeitems = [];
                    this.totalUserRows = 0;

                    this.noofpages=''
                    // this.employeeitems.length = 0,
                }
            })
            .catch((ex) => {
                console.log("error", ex);
            });
        },
        downloadReport() {
  let payload = null;  // declare here so it's always in scope

  try {
    const userdata = localStorage.getItem("userData");
    const userInfo = JSON.parse(userdata || "{}");

    const selectDate   = this.selectDate   ? this.formatDate(this.selectDate)   : "";
    const toselectDate = this.toselectDate ? this.formatDate(this.toselectDate) : "";

    let user_id = null;
    console.log("this.selected_employee--->", this.selected_employee);

    if (!this.selected_employee || this.selected_employee === 'null') {
      console.log("null--->11111111");
      user_id = null;
    } else {
      console.log("not null--->22222222", 'this.selected_employee');
      user_id = this.selected_employee && this.selected_employee.key || "";
    }

    const page_no = this.currentPage || 1;

    payload = {
      sysusermasterid: `${userInfo.sysusermasterid || ""}`,
      startdate: selectDate,
      enddate: toselectDate,
      user_id,
      warehouseid: this.valueWH || null,
      page_no,
      emp_name: this.valueEmpName || null,
      regularizationType: this.regularizationType || null,
      emp_id: this.empId || null,
      status: ["pending", "approved", "rejected"]
    };

    this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getCSVForFCRegularization`, payload)
      .then((res) => {
        const data = res.body || res.data || {};
        if (data.result === "success" && data.fileUrl) {
          const a = document.createElement("a");
a.href = data.fileUrl;
a.download = "AttendanceReport.csv";
document.body.appendChild(a);
a.click();
a.remove();
        } else {
          console.warn("Download failed:", data);
        }
      })
      .catch(err => {
        console.error("Download error:", err, payload); // payload available here
      });
  } catch (e) {
    console.error("Error in downloadReport:", e, payload); // payload available here
  }
},





clear(){

this.selectDate = new Date(),
this.toselectDate = new Date(),
this.valueWH =null;
this.regularizationType = null;
this.valueEmpName = null;
this.empId = null
this.EmployeeAllRequestList(this.pageNum);
},

        formatDate: function(date) {
            var d = new Date(date),
                month = "" + (d.getMonth() + 1),
                day = "" + d.getDate(),
                year = d.getFullYear();
            if (month.length < 2) month = "0" + month;
            if (day.length < 2) day = "0" + day;
            return [year, month, day].join("-");

        },

        

        showEmpIDlist: function() {

var userdata = localStorage.getItem("userData");
var userInfo = JSON.parse(userdata);

// this.employeelist=[];
const deliveryagentobj = {
    sysusermasterid: `${userInfo.sysusermasterid}`,
    usertype: `${userInfo.user_type}`,
    emp_name: this.valueEmpName ? this.valueEmpName : null,
};
// console.log("deliveryagentobj", deliveryagentobj);
// return false;
this.$http
.post(
`${CONSTANTS.MIGRATION_API_URL}/getAllFcClockRegularizationEmpListing`,deliveryagentobj

)
.then((result) => {
console.log("YYY", result);
if (result.body.returnmsg === 'Successful') {
  
      this.employeeIDList = result && result.data && result.data.returnvalue.map(item => item.employeeid)

  
  } else {              
    this.employeeIDList = []
  }

})
.catch((ex) => {
console.log("error", ex);
});
},
clickCallback (pageNum){


        this.EmployeeAllRequestList(pageNum);

},
  formatDateTime(dateStr, timeStr) {
    if (!dateStr || !timeStr) return "";

    // Combine into one datetime string
    const combined = `${dateStr.split("T")[0]}T${timeStr}`;
    const date = new Date(combined);

    return date.toLocaleString("en-US", {
      month: "long",  // March
      day: "2-digit", // 20
      year: "numeric", // 2024
      hour: "2-digit", // 05
      minute: "2-digit", // 12
      hour12: true // AM/PM
    });
  },
  getTimeDifference(start, end) {
    if (!start || !end) return "";

    // Convert to Date objects on the same day
    const [sh, sm] = start.split(":").map(Number);
    const [eh, em] = end.split(":").map(Number);

    const startDate = new Date(0, 0, 0, sh, sm);
    const endDate = new Date(0, 0, 0, eh, em);

    let diffMs = endDate - startDate;
    if (diffMs < 0) diffMs += 24 * 60 * 60 * 1000; // handle overnight times

    const diffMins = Math.floor(diffMs / 60000);
    const hours = Math.floor(diffMins / 60);
    const minutes = diffMins % 60;

    return `${hours} hours ${minutes} minutes`;
  },
  formatDateTimeNew(createdDate) {
  if (!createdDate) return "";

  const date = new Date(createdDate);

  // Format date: "Month Day, Year"
  const dateOptions = { year: 'numeric', month: 'long', day: 'numeric' };
  const formattedDate = date.toLocaleDateString('en-US', dateOptions);

  // Format time: "hh:mm AM/PM"
  const timeOptions = { hour: 'numeric', minute: '2-digit', hour12: true };
  const formattedTime = date.toLocaleTimeString('en-US', timeOptions);

  return `${formattedDate} at ${formattedTime}`;
},


    },
}
</script>

<style scope>
.Delivery_Dashboard .table thead tr{
    background: #f0f3f5 !important;
    border: 1px solid #c9b9b9 !important
}
.Delivery_Dashboard .table thead tr:hover {
    background: #f0f3f5 !important;
    border: 1px solid #c9b9b9 !important
}
.Delivery_Dashboard .table thead .bordercalls th{
    border: 0px solid rgb(227, 219, 219) !important;
}
.Delivery_Dashboard .table thead tr th, .Delivery_Dashboard .table thead tr td{
    border: 1px solid rgb(221, 208, 208) !important;
}
.Delivery_Dashboard .table thead .bordercalls .totalload{
    border: 1px solid #c9b9b9 !important
}
.btnclass{
    margin-top: 5px;
    padding-top: 0px;
    padding-bottom: 0px;
    margin-bottom: 5px;
}
/* .imgclass{
    padding-left: 116px;
} */
.detailsclass{
    font-weight: bold;
    font-size: medium;
}
.rowclass{
    padding-left: 2%;
}
.img{
    margin-left: 50px;

}

.imgclass-2 {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.modal-img {
    width: 600px;   
  height: 600px;   
  object-fit: contain; 
 }

 .float-right {
  float: right;
}
</style>